import { useEffect } from 'react';

export function useDebounceEffect(fn, waitTime, deps) {
  useEffect(() => {
    const handler = setTimeout(() => {
      // Call the function without applying deps as arguments
      fn();
    }, waitTime);

    return () => {
      clearTimeout(handler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fn, waitTime, ...deps]); // Explicitly spread deps in the dependency array
}
